(function () {
  function initCollectionDescriptionModal() {
    const description = document.querySelector(
      ".collection_description_content",
    );
    if (!description) return;

    const modalContainer = document.querySelector(
      ".modal_description_container",
    );
    const modal = document.querySelector(
      ".block_collection_description_wrapper",
    );
    const modalBox = document.querySelector(
      ".block_collection_description_box",
    );

    const openBtn = document.querySelector(".collection_read_more_btn");
    const closeBtn = document.querySelector(".block_collection_close_btn");

    if (!modal || !modalBox || !openBtn || !closeBtn) return;

    const previewParent = description.parentNode;

    function closeModal() {
      previewParent.insertBefore(description, openBtn);
      modal.classList.remove("active");
      document.body.style.overflow = "";
    }

    function openModal() {
      modalContainer.appendChild(description);
      modal.classList.add("active");
      document.body.style.overflow = "hidden";
    }

    openBtn.addEventListener("click", openModal);

    closeBtn.addEventListener("click", closeModal);

    modal.addEventListener("click", function (e) {
      if (!modalBox.contains(e.target)) {
        closeModal();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", initCollectionDescriptionModal);
})();
